import RadioBox from './src/RadioBox'

RadioBox.install = function (Vue) {
    Vue.component(RadioBox.name, RadioBox);
};

export default RadioBox;